import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"
export const config = {
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    // autocompleteMinLength: 1,
    historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    inputCssSelector: "#searchNs",
    contentCssSelector: "#ProductGridContainer",
    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.sort": "sort"
    },
    // Uncomment to redirect to search page instead of rendering on the same page
    serpPath: '/search',

    // Uncomment to redirect to search page instead of rewriting browser history
    serpPathRedirect: true,
    serpQuery: {
        products: {
            fields: [
                "productId",
                "url",
                "categories",
                "name",
                "tags1",
                "alternateImageUrls",
                "imageUrl",
                "thumbUrl",
                "description",
                "brand",
                "availability",
                "price",
                "priceText",
                "listPrice",
                "ratingValue",
                "reviewCount",
                "available",
                "skus.id",
                "customFields.key", 
                "customFields.value"
            ],
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0
        }
    },
    autocompleteQuery: {
        products: {
            fields: [
                "productId",
                "url",
                "categories",
                "name",
                "tags1",
                "alternateImageUrls",
                "imageUrl",
                "thumbUrl",
                "brand",
                "availability",
                "price",
                "priceText",
                "listPrice",
                "ratingValue",
                "reviewCount",
                "available",
                "skus.id",
                "customFields.key", 
                "customFields.value"
            ],
            size: defaultConfig.autocompleteProductsSize
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ["*"]
        }
    },
    compressUrlParameters: true,
    fallback: true,
    // Uncomment for Category Merchandising
    // categoryCssSelector: '#MainContent',
    categoryCssSelector: '#sectionCollectionItems',
    //categoryCssSelector: 'nostoTargetPLP',
    categoryQuery() {
        return {
            name: 'serp',
            products: {
                categoryId: this.categoryId(),
                // categoryPath: this.categoryPath(),
                size: defaultConfig.serpSize,
                from: 0,
            }
        }
    },
}